"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var utils_1 = require("../../../utils/utils");
var provider_1 = require("../../../theme/provider");
var textSizes = ["24", "18", "16", "14", "13", "12", "11"];
var StyledP = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n  padding: 0;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", "px;\n  line-height: 1.55em;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  margin: ", ";\n  padding: 0;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", "px;\n  line-height: 1.55em;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), function (props) { return (props.noMargin ? "0" : "0 0 1.55em 0"); }, function (props) {
    switch (props.type) {
        case "danger":
            return "#EB5757";
        case "primary":
        default:
            return (0, utils_1.getStylesBasedOnTheme)(props.theme.mode, props.theme.white, props.theme.textColor);
    }
}, function (props) { return (0, provider_1.getFontFromTheme)(props.theme).fontFamily; }, function (props) { return (props.bold ? "bold" : "normal"); }, function (props) { return props.size; });
var Text = function (props) {
    var children = props.children, noMargin = props.noMargin, style = props.style, bold = props.bold, _a = props.size, size = _a === void 0 ? "16" : _a, _b = props.type, type = _b === void 0 ? "primary" : _b, _c = props.className, className = _c === void 0 ? "" : _c;
    return ((0, jsx_runtime_1.jsx)(StyledP, __assign({ style: style, noMargin: noMargin, bold: bold, size: size, type: type }, props, { className: "wellms-component ".concat(className) }, { children: children })));
};
exports.Text = Text;
// https://styled-components.com/docs/api#using-custom-props
var NewText = (0, styled_components_1.default)(exports.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
// Main button with styles
exports.default = (0, styled_components_1.withTheme)(NewText);
var templateObject_1, templateObject_2;
